<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import api from "@/axios";
import CustomStore from 'devextreme/data/custom_store';
import DropZone from "@/components/widgets/dropZoneTexto";
import DropZonePlanilha from "@/components/widgets/dropZonePlanilha.vue";
import Swal from "sweetalert2";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations, DxHeaderFilter
} from 'devextreme-vue/data-grid';
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";
import moment from "moment/moment";
import {ref} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {

  components: {
    DropZone, DropZonePlanilha,
    DxItem, DxButton, DxToolbar, Layout, PageHeader, Loader,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxPager,  DxFilterRow, DxRemoteOperations, DxHeaderFilter
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },

  data() {
    return {
      title: "Contas a Pagar",
      items: [
        {
          text: "Financeiro",
          href: "/financeiros/cpagar"
        },
        {
          text: "Contas a Pagar",
          active: true
        }
      ],
      dataList: null,
      updating: false,
      showModalPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      totalizadores: [],

      showModalFileExtrato: false,
      showModalImportacaoFinanceiro: false,
      submittedFileExtrato: false,

    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted contasPagar-list_0')
    this.atualizaDataList()
  },

  methods: {
    confImportacaoFinanceiro(){
      console.log('confImportacaoFinanceiro')
      console.log(this.dropzoneFile)

      let arquivo = this.dropzoneFile;
      if(arquivo != null || arquivo != ""){
        /*
        * Verificando tamanho do arquivo e extensão
        * */
        // console.log('arquivo')
        // console.log(arquivo)
        let fileExtension = arquivo.name.split('.');
        console.log(`fileExtension: ${fileExtension[fileExtension.length - 1]}`)

        if(!['xlsx', 'xls'].includes(fileExtension[fileExtension.length - 1])) {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: 'Selecione um arquivo válido!',
            showConfirmButton: false,
            timer: 3500
          });
        } else {
          if(arquivo.size > 1000000){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: 'Arquivos com mais de 1MB devem ser tratados via suporte!',
              showConfirmButton: true,
            }).then(() => {
              //Limpando dropzone
              this.dropzoneFile = ""
            })
          }else{
            this.showModalImportacaoFinanceiro = false;
            this.updating = false;

            // Objeto form data
            let formData = new FormData();
            formData.append('filename', arquivo.name);
            formData.append('file', arquivo);

            api.post(`${getBaseUrl()}api/importfinanceiro`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((res) => {
              console.log('then axios');
              console.log(res);

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data[0],
                showConfirmButton: false,
                timer: 3500
              });

            }).catch((err) => {

              console.log('erro axios');
              // console.log(err)
              // console.log(err.response)
              // console.log(err.response.data.errors)
              let erros = err.response.data.errors;
              console.log(erros);
              console.log(typeof erros);
              let listaErros = [];
              Object.keys(erros).forEach(key => {
                console.log(key, erros[key]);
                listaErros.push({
                  'titulo': key,
                  'mensagem': erros[key]
                });
              });
              this.errosValid = listaErros;
              this.updating = false;
            });
          }
        }
      } else {
        console.log('error: dropzonefile is empty!')

        Swal.fire({
          position: "center",
          icon: "warning",
          title: 'Selecione pelo menos um arquivo válido!',
          showConfirmButton: false,
          timer: 3500
        });
      }
    },

    importarHistorico(){
      this.showModalImportacaoFinanceiro = true
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
    },


    confExtrato(){
      console.log('confExtrato')
      this.showModalFileExtrato = true
      if (this.dropzoneFile.name){
        this.showModalFileExtrato = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/extratofile`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.updating = false

          /*
            * Retornando dados response
            * */
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data[0],
            showConfirmButton: false,
            timer: 3500
          }).then(() => {
            /*
            * Limpando dropzone
            * */
            this.dropzoneFile = null
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },
    

    importarSicredi(){
      console.log('importarSicredi')
      this.showModalFileExtrato = true
    },


    novaConta(){
      console.log('novaConta')
      this.$router.push(`/cpagar/editar/0`)
    },


    nomeStatus(e) {
      switch (e.value) {
        case 'A':
          return 'Ativa (A)'
        case 'Q':
          return 'Quitado (Q)'
        case 'X':
          return 'Cancelado (X)'
        case 'RE':
          return 'Renegociado (RE)'
      }

      return e.value
    },

    nomeStatusBaixa(baixa) {
      switch (baixa.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'AB':
          return 'Em Aberto'
        case 'AG':
          return 'Agendado'
        case 'QT':
          return 'Quitado'
        case 'RE':
          return 'Renegociado'
      }

      return baixa.value
    },

    /*nomeCategoria(e) {
      switch (e.value) {
        case 'CI':
          return 'Compra de Insumos'
        case 'CF':
          return 'Compra de Fornecedores'
        case 'CR':
          return 'Compra de Mercadoria para Revenda'
        case 'CSP':
          return 'Custo de Serviços Prestados'
        case 'CST':
          return 'Custo de Serviços Tomados'
        case 'DA':
          return 'Despesa Administrativa'
        case 'DRH':
          return 'Despesa com Pessoal'
        case 'DC':
          return 'Despesa Comercial'
        case 'DV':
          return 'Devolução de Venda'
        case 'IM':
          return 'Impostos'
        case 'PC':
          return 'Perda de Capital'
        case 'TB':
          return 'Tarifa Bancária'
      }

      return e.value
    },*/

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'findi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'findf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))


      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    atualizaDataList(){
      console.log('atualizaDataList_contaPagar')


      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'findi': perIniPadrao,
          'findf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['findi']
        this.dtFimFiltro = filtros['findf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "financeiro_id",
        load: function(loadOptions) {
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }
          return api.get(`${getBaseUrl()}api/cpagar`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)

            this.totalizadores = response.data[2];

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    carregouGrid(e){
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
      this.title = `(${e.component.totalCount()}) Contas a Pagar: ${dtIniFormated} - ${dtFimFormated}`

      this.totalizadores = this.dataList.totalizadores;
    },



    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      const routeData = this.$router.resolve(`/cpagar/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "financeiro_stsbaixa") {

          let dataAtual = new Date(Date.now())
          dataAtual.setDate(dataAtual.getDate() + 1)

          const vencimentoParc = Date.parse(e.data.financeiro_vencimento)
          const baixaParcStatus = e.data.financeiro_stsbaixa

          let corStatus = 'rgba(78,59,0,0.5)'

          if(baixaParcStatus === 'AB' && (vencimentoParc < dataAtual)){
            corStatus = 'rgba(223,121,106,0.98)'
          } else {
            switch (baixaParcStatus) {
              case 'QT':
                corStatus = 'rgba(46,184,134,0.96)'
                break
              case 'AB':
                corStatus = 'rgba(248,178,58,0.82)'
                break
              case 'AG':
                corStatus = 'rgba(101,166,249,0.82)'
                break
              case 'RE':
                corStatus = 'rgba(14,114,244,0.82)'
                break
            }
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }

        this.onCellValorAbertoPrepared(e)
        this.onCellVencimentoPrepared(e)
      }
    },

    onCellValorAbertoPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "financeiro_valorabe") {

          let dataAtual = new Date(Date.now())
          dataAtual.setDate(dataAtual.getDate() + 1)

          const vencimentoParc = Date.parse(e.data.financeiro_vencimento)
          const baixaParcStatus = e.data.financeiro_stsbaixa
          const valParcStatus = e.data.financeiro_valorabe

          let corCell = 'rgb(46,184,134,0.96)'

          if(valParcStatus > 0){
            if(baixaParcStatus === 'AB' && (vencimentoParc < dataAtual)){
              corCell = 'rgba(223,121,106,0.98)'
            }else {
              corCell = 'rgba(248,178,58,0.82)'
            }
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corCell}`;

        }
      }
    },

    onCellVencimentoPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "financeiro_vencimento") {
          let dataAtual = new Date(Date.now())
          dataAtual.setDate(dataAtual.getDate() + 1)

          const vencimentoParc = Date.parse(e.data.financeiro_vencimento)
          let corCell = 'rgba(78,59,0,0.5)'

          if(vencimentoParc < dataAtual){
            corCell = 'rgba(223,121,106,0.98)'
          }else{
            if(e.data.financeiro_stsbaixa !== "QT"){
              corCell = 'rgba(248,178,58,0.82)'
            } else {
              corCell = 'rgba(46,184,134,0.96)'
            }
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corCell}`;

        }
      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return Number(value_n).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return 0.00;
    },

    formatInteger(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>
      <div class="card-body border-top mb-3">
        <h5 class="text-truncate mb-4">Panorama geral do período Filtrado:</h5>
        <div class="text-center">
          <div class="row">
            <div class="col-sm-3">
              <div>
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-line-chart text-info"></i>
                </div>

                <p class="text-muted mb-2">Geral</p>
                <h5>{{ this.totalizadores.geral }}</h5>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bx-check-double text-success"></i>
                </div>

                <p class="text-muted mb-2">Quitados</p>
                <h5>{{ this.totalizadores.quitado }}</h5>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bxs-comment-detail text-warning"></i>
                </div>
                <p class="text-muted mb-2">Em Aberto</p>
                <h5>{{ this.totalizadores.emAberto }}</h5>
              </div>
            </div>

            <div class="col-sm-3">
              <div class="mt-4 mt-sm-0">
                <div class="font-size-24 text-primary mb-2">
                  <i class="bx bxs-comment-error text-danger"></i>
                </div>

                <p class="text-muted mb-2">Vencido</p>
                <h5>{{ this.totalizadores.vencido }}</h5>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="add"
              hint="Criar Nova"
              :on-click="novaConta"/>
        </DxItem>

<!--        <DxItem-->
<!--            location="before"-->
<!--            widget="dxButton">-->
<!--          <DxButton-->
<!--              icon="xlsxfile"-->
<!--              hint="Importar histórico de contas a pagar"-->
<!--              :on-click="importarHistorico"/>-->
<!--        </DxItem>-->

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="upload"
              hint="Importar extrato Sicredi"
              :on-click="importarSicredi"/>
        </DxItem>

      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">


      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @content-ready="carregouGrid"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />


        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strContasPagarList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />


        <DxColumn
            sort-order="desc"
            data-field="financeiro_id"
            caption="ID"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith','=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_codigo"
            caption="Código"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_numero"
            caption="Número"
            alignment="right"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pe_nome"
            caption="Fornecedor"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pe_cnpj"
            caption="CNPJ"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="financeiro_stsbaixa"
            caption="Status"
            alignment="center"
            data-type="text"
            :customize-text="nomeStatusBaixa"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="financeiro_status"
            caption="Condição"
            alignment="center"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="financeiro_categoria"
            caption="Categoria"
            alignment="center"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />

        <DxColumn
            data-field="financeiro_emissao"
            caption="Emissão"
            alignment="right"
            data-type="date"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_vencimento"
            caption="Vencimento"
            alignment="right"
            data-type="date"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_compet"
            caption="Competência"
            alignment="right"
            data-type="date"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_dtbaixa"
            caption="Dt.Baixa"
            alignment="right"
            data-type="date"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_valor"
            caption="Valor"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>','<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="financeiro_valorabe"
            caption="Valor em aberto"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="financeiro_valorqit"
            caption="Valor quitado"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="financeiro_razaoParcelas"
            caption="Razão das parcelas"
            alignment="right"
            type="text"
            :allowFiltering="false"
            :allowHeaderFiltering="false"/>


        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[20, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[20, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Arquivo Extrato Bancário Sicredi" v-model="showModalFileExtrato" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedFileExtrato && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFileExtrato = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confExtrato">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Importação histórico financeiro" v-model="showModalImportacaoFinanceiro" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZonePlanilha @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedFileExtrato && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImportacaoFinanceiro = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImportacaoFinanceiro">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>